export default __webpack_public_path__ + "static/media/package-c-small.6e40bf55.jpg";